import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable ,throwError } from 'rxjs';
import { User } from '../Services/WOWApi.Service';
import { CustomServiceService } from '../Services/custom-service.service';

@Injectable()
export class HttpAuthTokenInterceptor implements HttpInterceptor {

  constructor(private customServices:CustomServiceService) {}
  loggedUser: User; 
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
     
      this.loggedUser = this.customServices.GetLoggedInUser();
      if(this.loggedUser !=  null)
        request = request.clone({ headers: request.headers.append('Authorization', `Bearer ${this.loggedUser.token}`) });       
      
      
      
     return next.handle(request)
     .pipe(
         catchError((error: HttpErrorResponse) => {
             let errorMsg = '';
             if (error.error instanceof ErrorEvent) {
                 console.log('This is client side error');
                 errorMsg = `Error: ${error.error.message}`;
                  
             } else {
                 console.log('This is server side error');
                 errorMsg = `Error Code: ${error.status},  Message: ${error.message}`;
             }
             if(error.status == 401)
             {
              localStorage.removeItem("UserInfo");
    
              window.location.href = "/login";
             }
             console.log(errorMsg);
             return throwError(errorMsg);
         })
     )
    
  }
}
